export default {
      id: "Icon--language-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--language",
      toString: function () {
        return this.url;
      }
    }